<template lang="html">
  <main class="login-bg">
  	<div class="aligner">

  		<p id="screenReaderTargetLogin" class="sr-only">Login side</p>

  		<div class="login-explanation" v-if="action == 'explain'">
				<h2 class="white-text text-center">Odense Rundt</h2>
				<p>
					Opret en profil og få mulighed for at føje steder og temaer i Odense Rundt til dine favoritter. <br>
					Profilen giver dig adgang til en række personlige indstillinger, så du fx kan samle dine favorit-steder, indstille din cykelhastighed og tilføje de adresser, du ofte bruger.
				</p>
        <router-link :to="{path: '/login'}"><button class="btn generic-login-btn blue">Login eller opret bruger</button></router-link>
				<button class="generic-login-btn btn" onclick="history.back();">Gå tilbage</button>
  		</div>

  		<div class="choose-login-type" v-if="!action">
				<img src="@/assets/img/web_logo_knud.png" id="login-logo" alt="Odense Rundt logo"/>
				<form>
					<input type="email" placeholder="E-mail" aria-label="Din email" :class="{'error-outline' : emailError || userInactiveError}" v-model="userEmail">
					<input type="password" placeholder="Password" aria-label="Dit kodeord" :class="{'error-outline' : passwordError}" v-model="userPassword">
					<div class="email-error error" v-show="emailError">Forkert e-mail</div>
					<div class="user-inactive-error error" v-show="userInactiveError">Din bruger er endnu ikke aktiveret. Vi har sendt et aktiveringslink til din email.</div>
					<div class="password-error error" v-show="passwordError">Forkert password</div>

          <div class="form-check">
  					<input type="checkbox" id="login-remember-me" class="form-check-input" aria-label="Forbliv logget ind" v-model="rememberLogin">
            <label class="form-check-label" for="login-remember-me"><p class="white-text">Forbliv logget ind</p></label>
          </div>

          <button id="submit-btn" class="btn blue" @click="submitLogin">Login</button>

          <router-link :to="{path: '/login/reset'}"><p class="white-text password-reset-link">Glemt dit kodeord?</p></router-link>
          <router-link :to="{path: '/register'}"><p class="white-text new-user-link">Opret ny bruger</p></router-link>
				</form>

				<div class="white-text text-center">
          <div class="white-line"></div>
          <p style="display: inline-block; margin: 0px 5px;">eller</p>
          <div class="white-line"></div>
        </div>

				<button id="facebook-btn" class="btn" @click="fbLogin">Login via Facebook</button>
  		</div>

  		<div class="email-reset" v-if="action == 'reset'">
        <div v-if="emailResetSucces">
  				<p class="white-text">Vi har sendt en besked til din email med instruktioner om hvordan du nulstiller dit password.</p>
  				<router-link :to="{path: '/login'}"><button class="generic-login-btn btn blue">Gå til login</button></router-link>
    		</div>
        <div v-else>
  				<h2 class="white-text">Nulstil dit password</h2>
  				<input type="email" placeholder="E-mail" aria-label="Din email" v-model="userEmailReset">
  				<div class="error" v-show="passwordResetError">Email eksistere ikke.</div>
  				<button class="generic-login-btn btn blue" @click="resetPassword">Nulstil</button>
        </div>
  		</div>

  	</div>
  </main>
</template>

<script>
import Profile from '@/assets/profile/Profile.js'
import axios from 'axios'
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
      emailError: false,
      userInactiveError: false,
      passwordError: false,
      passwordResetError: false,
      emailResetSucces: false,
      userEmail: '',
      userPassword: '',
      rememberLogin: false,
    }
  },
  props: {
    action: {
      default: false,
    }
  },
  created() {
    this.$HelperFunctions.scrollToTop();
    this.$HelperFunctions.setPageTitle('Login');
  },
  mounted() {
    this.$HelperFunctions.setScreenReaderFocus('screenReaderTargetLogin');
  },
  methods: {
  	submitLogin(e) {
  		e.preventDefault();
      this.emailError = this.passwordError = this.userInactiveError = false;
      Profile.login(this.userEmail, this.userPassword, this.rememberLogin).then((response) => {
        if(response.data.type == 'login_ok') {
          Profile.getUserData();
          setTimeout(() => {
            EventBus.$emit('loggedIn');
            this.$router.push('/profile');
          }, 1000);
        }
        else if(response.data.type == 'login_error.user') {
  				this.emailError = true;
  				var focusElem = document.getElementsByClassName('email-error');
  			}
  			else if(response.data.type == 'login_error.pass') {
  				this.passwordError = true;
  				var focusElem = document.getElementsByClassName('password-error');
  			}
  			else if(response.data.type == 'user.inactive') {
          this.userInactiveError = true;
  				var focusElem = document.getElementsByClassName('user-inactive-error');
  			}

  			if(response.data.type == 'login_error.user' || response.data.type == 'login_error.pass' || response.data.type == 'user.inactive') {
  				focusElem[0].setAttribute("tabindex", "-1");
  				focusElem[0].style.outline = "none";
  				focusElem[0].focus();
  			}
      });
  	},

    fbLogin() {
      window.fbAsyncInit = function() {
    		FB.init({
    		appId      : '573490632843110',
    		cookie     : true,  // enable cookies to allow the server to access the session
    		xfbml      : true,  // parse social plugins on this page
    		version    : 'v3.2' // use graph api version 3.2
    		});
    		// Now that we've initialized the JavaScript SDK, we call
    		// FB.getLoginStatus().  This function gets the state of the
    		// person visiting this page and can return one of three states to
    		// the callback you provide.  They can be:
    		//
    		// 1. Logged into your app ('connected')
    		// 2. Logged into Facebook, but not your app ('not_authorized')
    		// 3. Not logged into Facebook and can't tell if they are logged into
    		//    your app or not.
    		//
    		// These three cases are handled in the callback function.
    	};

    	(function(d, s, id){
    	var js, fjs = d.getElementsByTagName(s)[0];
    	if (d.getElementById(id)) {return;}
    	js = d.createElement(s); js.id = id;
    	js.src = "https://connect.facebook.net/en_US/sdk.js";
    	fjs.parentNode.insertBefore(js, fjs);
    	}(document, 'script', 'facebook-jssdk'));

      setTimeout(() => {
        FB.login((response) => {
          this.fbLoginRespond(response);
        }, {scope: 'public_profile'});
      }, 500);
    },

  	fbLoginRespond(response) {
  		//console.log(response);
  		if(response.status == "connected") {
  			var userId = response.authResponse.userID;
        const params = new URLSearchParams();
        params.append('action', 'checkfb');
        params.append('userId', userId);

        axios({
          method: 'post',
          url: 'https://apps.odenserundt.dk/apptools/orApi/',
          data: params
        }).then((response) => {
  				if(typeof response.data.key !== 'undefined') {
  					Profile.loginType = 'facebook';
  					Profile.loggedIn = true;
  					Profile.userKey = response.data.key;
  					Profile.saveLogin(response.data.key, 'facebook');
  					Profile.getUserData();
  					setTimeout(() => {
              EventBus.$emit('loggedIn');
  						this.$router.push('/profile');
  					}, 1000);
  				}
  			});
  		}
  	},

  	resetPassword() {
      this.passwordResetError = false;

      const params = new URLSearchParams();
      params.append('action', 'resetPass');
      params.append('email', this.userEmailReset);
      axios({
        method: 'post',
        url: 'https://apps.odenserundt.dk/apptools/orApi/',
        data: params
      }).then((response) => {
  			if(response.data.type == 'Email not found.') {
  				this.passwordResetError = true;
  			}
  			else {
          this.emailResetSucces = true;
  			}
  		});
  	},
  },
}
</script>

<style lang="css" scoped>
  .login-bg {
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-filter: grayscale(50%);
    filter: grayscale(50%);
    background-image: url('https://apps.odenserundt.dk/apptools/img/login-bg.jpg');
  }

  .aligner {
    text-shadow: 0 1px 3px rgba(0,0,0,.5);
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  input[type="email"], input[type="password"] {
  	width: 100%;
  	height: 40px;
  	line-height: 40px;
  	border: 1px solid #dbdbdb;
  	padding-left: 5px;
  }

  .login-explanation, .choose-login-type, .email-reset {
    width: 300px;
  }

  .login-close-btn {
  	position: absolute;
  	top: 10px;
  	right: 10px;
  	color: #f8f8f8;
  }

  #login-logo {
  	position: relative;
  	margin-bottom: 10px;
  }

  .login-explanation p {
    background-color: rgba(255,255,255,0.8);
    padding: 10px;
    text-shadow: none;
  }

  .password-reset-link {
    display: inline-block;
    margin-top: 10px;
    font-size: 15px;
    text-decoration: underline;
  }

  .new-user-link {
    display: inline-block;
    float: right;
    margin-top: 10px;
    font-size: 15px;
    text-decoration: underline;
  }

  #submit-btn, #facebook-btn, #email-btn, .generic-login-btn {
  	display: block;
  	margin-top: 10px;
  	width: 300px;
  	height: 40px;
  	border-radius: 2px;
  	background-color: #f8f8f8;
  }

  #submit-btn {
  	margin-top: 0px;
  }

  #facebook-btn {
  	margin-bottom: 10px;
  	background-color: #3b5998;
  	color: #fff;
  }

  #facebook-btn, #email-btn {
  	position: relative;
  	left: 50%;
  	margin-left: -150px;
  }

  #email-btn {
  	margin-bottom: 10px;
  }

  .white-line {
  	display: inline-block;
  	position: relative;
  	top: -3px;
  	height: 1px;
  	width: 133px;
  	background-color: #f8f8f8;
  }

  .error {
  	padding-left: 5px;
  	background-color: #fff;
  	color: red;
  	text-shadow: none;
  	text-align: left;
  	border: 1px solid #e6177a;
  	border-top: none;
  }

  .error-outline {
  	border: 1px solid #e6177a !important;
  }
</style>
